import { getUserMail } from "../../services/util/getUserMail";
import { axiosESMultiday } from "../axios";
// let userObj:any = {'email_id' : getUserMail()}

export async function getTotalHistoricalPlPercentageES(startDate:any,endDate:any,asset:any) {
    try {
        let userObj:any = {'email_id' : getUserMail()}
        const res = await axiosESMultiday.post(`/equity-spot-multiday/get_total_pl_percent`, {
            "startDate":startDate,
            "endDate":endDate,
            "asset" : asset,
        });
        return res?.data;
    } catch (err) {
        return console.log(err);
    }
}

export async function getHistoricalPlPercentageES(startDate:any,endDate:any,type: any,version: any, filterDropdownVersion:any, returnType:any) {
    try {
        let userObj:any = {'email_id' : getUserMail()}
        const res = await axiosESMultiday.post(`/equity-spot-multiday/get_pl_percent`, {
            "version": version,
            "asset": type,
            "startDate":startDate,
            "endDate":endDate,
            "username": userObj?.email_id,
            "filterDropdownVersion" : filterDropdownVersion,
            "typeOfInvestment" : returnType
        });
        return res?.data;
    } catch (err) {
        return console.log(err);
    }
}

export async function getHistoricalCallsES(startDate:any, endDate:any, type:any,version:any, filterDropdownVersion:any) {
    // startDate, endDate, asset,version
    try {
        let userObj:any = {'email_id' : getUserMail()}
        const res = await axiosESMultiday.post(`/equity-spot-multiday/get_calls`, {
            "version": version,
            "asset": type,
            "startDate":startDate,
            "endDate":endDate,
            "username": userObj?.email_id,
            "filterDropdownVersion" : filterDropdownVersion
        });
        return res?.data;
    } catch (err) {
        return console.log(err);
    }
}

export async function getHistoricalSRES(startDate:any, endDate:any, type:any, version:any, filterDropdownVersion:any) {
    // startDate, endDate, asset, version, filterDropdownVersion
    try {
        let userObj:any = {'email_id' : getUserMail()}
        const res = await axiosESMultiday.post(`/equity-spot-multiday/get_sr`, {
            "version": version,
            "asset": type,
            "startDate":startDate,
            "endDate":endDate,
            "username": userObj?.email_id,
            "filterDropdownVersion" : filterDropdownVersion
        });
        return res?.data;
    } catch (err) {
        return console.log(err);
    }
}
export async function getHistoricalPlES(startDate:any, endDate:any, type:any, version:any, filterDropdownVersion:any) {
    // startDate, endDate, asset, version, filterDropdownVersion
    let userObj: any = { 'email_id': getUserMail() }
    return await axiosESMultiday.post(`/equity-spot-multiday/get_pl`, {
        "version": version,
        "asset": type,
        "startDate": startDate,
        "endDate": endDate,
        "username": userObj?.email_id,
        "filterDropdownVersion": filterDropdownVersion
    }).then((res: any) => {
        return res?.data;
    }).catch((err: any) => {
        return console.log(err);
    })
}

export async function getHistoricalTradesES(startDate:any,endDate:any,type: any,version: any, filterDropdownVersion:any) {
    try {
        let userObj: any = { 'email_id': getUserMail() }
        const res = await axiosESMultiday.post(`/equity-spot-multiday/get_trades`, {
            "version": version,
            "asset": type,
            "startDate":startDate,
            "endDate":endDate,
            "username": userObj?.email_id,
            "filterDropdownVersion" : filterDropdownVersion
        });
        return res?.data;
    } catch (err) {
        return console.log(err);
    }
}

export async function getParameterES(id: any, asset: any, version: any, date: any){
    try {
        const res = await axiosESMultiday.post(`/equity-spot-multiday/get_parameter`, {
            "id": id,
            "asset": asset,
            "version": version,
            "date": date,
        });
       
        return res?.data;
    } catch (err) {
        return console.log(err);
    }

}

export async function getMtmDrawdownES(id: any, asset: any, version: any, date: any){
    try {
        let userObj: any = { 'email_id': getUserMail() }
        const res = await axiosESMultiday.post(`/equity-spot-multiday/get_m2m_drawdown`, {
            "id": id,
            "asset": asset,
            "version": version,
            "date": date,
            "username": userObj?.email_id
        });
        return res?.data;
    } catch (err) {
        return console.log(err);
    }
   
}

export async function getTargetSlES(id: any, asset: any, version: any, date: any){
    try {
        let userObj: any = { 'email_id': getUserMail() }
        const res = await axiosESMultiday.post(`/equity-spot-multiday/get_target_stoploss`, {
            "id": id,
            "asset": asset,
            "version": version,
            "date": date,
            "username": userObj?.email_id
        });
        return res?.data;
    } catch (err) {
        return console.log(err);
    }
}


